import Vue from "vue";
import LightBox from 'vue-it-bigger'

Vue.component('light-box', LightBox);

Vue.component("wto-video-viewer", {
	props: ["media"],
	data() {
		return {			
		};
	},
	methods: {
		openGallery(index) {
			this.$refs.lightbox.showImage(index);
		},
		onVideoClosed: function(){
			this.$refs.lightbox.nextImage();
		}
	},
	template: `
      <div class="columns" style="flex-wrap: wrap">
		  <div class="column is-3" v-for="(image, index) in media" :key="index">
			  <ul style="margin: 0; padding: 0">
				<li	 style="display: inline-block;">
				  <div class="truncate-overflow-1" :title="image.caption">{{ image.caption }}</div>
				  <img :src="image.thumb" style="height: 180px; width:320px; cursor: pointer" @click="openGallery(index)">
				</li>
			  </ul>
		  </div>
          <light-box ref="lightbox" @onClosed="onVideoClosed" :media="media" :show-caption="true" :show-light-box="false"/>
      </div>
	`
});
